




























































import { Component, Vue } from 'vue-property-decorator'
import { ActionTypes } from '@/store/action-types'
import { MutationTypes } from '@/store/mutation-types'
import { LOCALES } from '@/i18n/locales'
import { defaultLocale } from '@/i18n'
import ApiGtag, { Category } from '@/services/api-gtag'

@Component({
  data: () => ({ LOCALES, defaultLocale })
})
export default class UserMenuDropdown extends Vue {
  private messagesCount = 4
  private projectsCount = 43
  private showLabs = localStorage.getItem('showLabs') === 'true' || false

  private logout() {
    const username = this.$store.state.user.username
    this.$store.dispatch(ActionTypes.AUTH_LOGOUT)
    ApiGtag.sendEvent(Category.User, 'Logout', username)
  }

  private profile() {
    window.open('https://myaccount.microsoft.com/', '_blank')
  }

  private setLocale(event: { target: { value: string } }) {
    this.$i18n.locale = event.target.value
    this.$store.commit('SET_ACTIVE_LANG', this.$i18n.locale)
    this.$gtag.config({
      user_id: this.$store.state.user.username,
      language: this.$i18n.locale
    })
    ApiGtag.sendEvent(Category.User, 'Locale Change', this.$i18n.locale)
    localStorage.setItem('userLocale', this.$i18n.locale)
  }

  private tooglelabs() {
    this.$store.commit(MutationTypes.SET_SHOW_LABS)
  }

  created() {
    if (!this.$store.state.user.username) {
      this.$store.dispatch(ActionTypes.USER_REQUEST)
    }
  }
}
